import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { ApiClientService } from "@shared/_services/api-client.service";
import Swal from "sweetalert2";
import { NgxPaginationModule } from "ngx-pagination";
import { ToastrModule } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import { RouterModule } from '@angular/router';
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';
import { ActivatedRoute } from '@angular/router';
import { UserDevicesComponent } from './user-devices/user-devices.component';
import { UserThemesComponent } from './user-themes/user-themes.component';
import { UserSubscriptionsComponent } from './user-subscriptions/user-subscriptions.component';
import { UserHistoryComponent } from './user-history/user-history.component';
import { Observable, Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { DeviceLocationService } from '@app/shared/_services/device-location.service';
@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ToastrModule,
    NgxPaginationModule,
    RouterModule,
    PreloaderComponent,
    UserDevicesComponent,
    UserThemesComponent,
    UserSubscriptionsComponent,
    UserHistoryComponent
  ],
  providers: [
    ToastrService
  ],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.css'
})
export class UserProfileComponent {
  public loading: boolean = false;
  public hasError: boolean = false;
  public errorMsg: string = '';
  public userDetails: any = {};
  public userDevices: any[] = [];
  public userId: string = '';
  public totalItems: number = 0;
  public currentPage: number = 1;
  public pageSize: number = 10;
  selectedTab: string = 'profile';
  public urlPath: string = '';
  public applicationObj$!: Observable<any>;
  public objSubscription!: Subscription;

  public subscription: Subscription = new Subscription();

  // Date range for downloading locations
  public startDateInput: string = '';
  public endDateInput: string = '';

  constructor(
    private _apiClientService: ApiClientService,
    private route: ActivatedRoute,
    private _toastrService: ToastrService,
    private deviceLocationService: DeviceLocationService
  ) { }

  ngOnInit() {
    this.urlPath = window.location.href;

    console.log(this.urlPath.split('/')[6]);
    this.selectTab(this.urlPath.split('/')[6]);
    this.userId = this.urlPath.split('/')[5];

    this.setDefaultDateRange();
    this.getUserDetails();
  }

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  public async getUserDetails() {
    this.loading = true;
    (await this._apiClientService.readAllApiService(`admin/itt-user/${this.userId}/detail`)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            //console.log("Users Details ", event.body);
            let data = event.body;
            //if (status == 200) {

            this.userDetails = data;
            this.userDevices = data.devices;
          //console.log(this.userDetails);
          //this._userDataService.setData(this.userDetails);
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  private toInputDateTimeLocalString(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }

  private setDefaultDateRange(): void {
    const now = new Date();
    const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    this.endDateInput = this.toInputDateTimeLocalString(now);
    this.startDateInput = this.toInputDateTimeLocalString(yesterday);
  }

  public onDownloadLocations(): void {
    if (!this.startDateInput || !this.endDateInput) {
      this._toastrService.error('Please select both start and end dates', 'Invalid date range');
      return;
    }
    const start = new Date(this.startDateInput);
    const end = new Date(this.endDateInput);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      this._toastrService.error('Invalid date values', 'Invalid date range');
      return;
    }

    if (start > end) {
      this._toastrService.error('Start date must be before end date', 'Invalid date range');
      return;
    }

    if (!this.userId) {
      this._toastrService.error('User ID not found', 'Cannot download locations');
      return;
    }

    // Trigger KML download via service (navigates browser to file URL)
    this.deviceLocationService.downloadUserLocationKmlFile(start, end, this.userId);
    this._toastrService.info('Preparing location download...', 'Download started');
  }

  triggerUpdate(adminUser: any) {
    console.log(adminUser);
    const self = this;
    Swal.fire({
      title: 'Set Admin User',
      text: 'Do you want to set this user as an admin user?',
      icon: "info",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#4bd08b', // Green color for Yes button
      cancelButtonColor: '#9b9b9b',  // Red color for No button
    }).then((result: any) => {
      /* Read more about isConfirmed, isDenied below */
      console.log(result.isConfirmed);
      if (result.isConfirmed) {
        console.log(result);
        this.updateUser(adminUser);
      }
    });
  }

  public async updateUser(adminUser: any) {
    this.loading = true;
    (await this._apiClientService.addApiService(`admin/admin-user/add`, { userId: adminUser.id })).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("Region Deleted ", event.body);
            this._toastrService.success('User set as an admin user', 'Success');
            let { status, error, message, data } = event.body;

            this.getUserDetails();
          //if (status == 200) {
          //this.getAllUsers();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  triggerDisableUser(user: any) {
    Swal.fire({
      title: 'Disable User',
      text: `Do you want to disable ${user.name}? They will be logged out of all devices.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Disable User',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#f59e0b',
      cancelButtonColor: '#9b9b9b',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.updateUserStatus(user, 'Suspended');
      }
    });
  }

  triggerEnableUser(user: any) {
    Swal.fire({
      title: 'Enable User',
      text: `Do you want to enable ${user.name}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Enable User',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#10b981',
      cancelButtonColor: '#9b9b9b',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.updateUserStatus(user, 'Active');
      }
    });
  }

  public async updateUserStatus(user: any, status: string) {
    this.loading = true;
    (await this._apiClientService.patchApiService(`admin/itt-user`, `${user.id}/status`, { status })).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            if (status === 'Suspended') {
              this._toastrService.success(`${user.name} has been disabled.`, 'User Disabled');
            } else {
              this._toastrService.success(`${user.name} has been enabled.`, 'User Enabled');
            }
            this.getUserDetails();
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message || errorObj?.error?.message;
        this._toastrService.error(
          errorMsg || 'Something went wrong. Please contact Technical Support.',
          'Update Failed'
        );
      }
    );
  }

  triggerDeleteUser(user: any) {
    Swal.fire({
      title: 'Delete User',
      text: `Do you want to delete ${user.name}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete User',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#9b9b9b',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.deleteUser(user);
      }
    });
  }

  public async deleteUser(user: any) {
    this.loading = true;
    (await this._apiClientService.deleteApiService(`admin/itt-user`, user.id)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            this._toastrService.success('Success', 'Deleted User Successfully');
            window.history.back();
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message || errorObj?.error?.message;
        this._toastrService.error(
          errorMsg || 'Something went wrong. Please contact Technical Support.',
          'Delete Failed'
        );
      }
    );
  }


  
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
